import { services } from '../../services';
var action = "manage/property-service";

export const propertyServiceService = {
    getList,
    getOne,
    insert,
    update,
    remove,
};

function getList(param = '') {
    return services.restApi(`${action}${param}`, 'GET');
}

function getOne(id) {
    return services.restApi(`${action}/${id}`, 'GET');
}

function insert(object) {
    return services.restApi(`${action}/insert`, 'POST', object);
}

function update(id, object) {
    return services.restApi(`${action}/${id}`, 'PUT', object);
}

function remove(id) {
    return services.restApi(`${action}/${id}`, 'DELETE');
}
